import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import cl from './index.module.scss'
import { SimpleBtnProps, SimpleButton } from '../From/SimpleButton'
import { BtnSettings, DuetButtons } from '../ActionButtons/DuetButtons'


type Props = {
    isShow: boolean
    changed?: (visible: boolean) => void
    children: ReactNode
}

export const Modal: React.FunctionComponent<Props> = (props) => {
    if (!props.isShow) {
        return null
    }
    const close = () => {
        props.changed && props.changed(!props.isShow)

    }
    const prevent = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation()
        return false
    }
    return (
        <>
            <div className={cl.bg}></div>
            <div className={cl.content} onClick={close}>
                <div className={cl.modal} onClick={prevent}>
                    <div className={cl.modal__content}>
                        {props.children}
                    </div>
                    <div className={cl.modal__close} onClick={close}>X</div>
                </div>
            </div>
        </>
    )
}


export const ModalWithButton: React.FC<{
    isShow?: boolean
    children: ReactNode
    modal?: Omit<Props, 'isShow' | 'children'>
    btn: Omit<SimpleBtnProps, 'click'> & { click?: () => void }
    onClosed?: () => void
    duetBtn?: {
        first?: 'cancel' | BtnSettings | ReactNode
        second?: BtnSettings | ReactNode
    }
    disabled?: boolean
}> = (props) => {
    const [isShow, setIsShow] = useState(props.isShow || false)
    const [first, setFirst] = useState(props.duetBtn?.first as ReactNode | BtnSettings | undefined)
    const [second, setSecond] = useState(props.duetBtn?.second as ReactNode | BtnSettings | undefined)
    useEffect(() => {
        setIsShow(props.isShow === true)
    }, [props.isShow])
    useEffect(() => {
        if (!props.duetBtn?.second) {
            return setSecond(undefined)
        }
        if (React.isValidElement(props.duetBtn.second)) {
            return setSecond(props.duetBtn.second)
        }
        const second: BtnSettings = props.duetBtn.second as BtnSettings
        setSecond({
            ...second,
            action: () => {
                const isClose = second.action(setIsShow)
                if (isClose) {
                    setIsShow(false)
                }
            },
            disabled: second.disabled || props.disabled,
        })
    }, [props.duetBtn])
    useEffect(() => {
        if (!props.duetBtn?.first) {
            return setFirst(undefined)
        }
        if (typeof props.duetBtn.first === 'string' && props.duetBtn.first === 'cancel') {
            return setFirst({
                type: 'transparent',
                content: 'Отменить',
                action: btnClose,
                disabled: props.disabled,
            })
        }
        if (React.isValidElement(props.duetBtn?.first)) {
            return setFirst(props.duetBtn?.first)
        }
        const first: BtnSettings = props.duetBtn?.first as BtnSettings
        setFirst({
            ...first,
            action: () => {
                setIsShow(false)
                first.action()
            },
        })
    }, [props.duetBtn])

    const btnOpen = useCallback(() => {
        props.btn.click && props.btn.click()
        setIsShow(true)
    }, [])
    const btnClose = useCallback(() => {
        setIsShow(false)
        props.onClosed && props.onClosed()
    }, [])
    return (
        <>
            <SimpleButton {...props.btn} click={btnOpen} disabled={props.disabled}/>
            <Modal {...(props.modal || {})} isShow={isShow} changed={btnClose}
            >
                {props.children}
                {
                    props.duetBtn
                        ? (
                            <DuetButtons
                                first={first}
                                second={second}
                                disabled={props.disabled}/>
                        ) : undefined
                }
            </Modal>
        </>
    )
}